import { Component, OnInit, Input } from '@angular/core';
 
 
import { ConfirmedDialogComponent } from 'src/app/shared/dialogs';
import { Contact } from 'src/app/entity/Contact';
import { ContactService } from 'src/app/service/contact.service';
import { Prospect } from 'src/app/entity/prospect';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
 
@Component({
  selector: 'list-contacts-prospect',
  templateUrl: './contacts-prospect.component.html',
  styleUrls: ['./contacts-prospect.component.scss']
})
export class ContactsProspectComponent implements OnInit {

  @Input()
  prospect: Prospect;
  dataSource = new MatTableDataSource();;

 

  constructor(private contactService: ContactService, private dialog: MatDialog) { }

  ngOnInit() {
    this.findContacts();
  }
  findContacts() {
    //console.log("this.prospect"+JSON.stringify(this.prospect));
    
    this.contactService.findContactsByProspect(this.prospect.prospectId).subscribe(data => {
      this.dataSource.data = data;
 
    })

  }

  select(contact: Contact) {
   
    
 
  }
  ajouterNouveau() {
    let contact = new Contact();
    contact.nom = "new Contact";
    contact.prospectId=this.prospect;
    this.contactService.addContact(contact).subscribe(result => {
      this.findContacts();
    })
  }
 
  deleteContact(contact: Contact): void {
    // Create configuration for the dialog
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '200px';
    dialogConfig.width = '400px';
    dialogConfig.data = { 
        title: `Delete  ${contact.nom}  `,
        message: 'Are you sure?'
    };

    const dialogRef = this.dialog.open(ConfirmedDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
        if (result) {
 
            this.contactService.deleteContact(contact).subscribe(result=>{
this.contactService.findContactsByProspect(contact.prospectId.prospectId).subscribe(result=>{
  this.dataSource.data=result;
})
            })
        }
    });
}

}
